import React from 'react';
import { BaseField } from 'react/components/fields';
import PropTypes from 'prop-types';
import CrudContext from 'react/contexts/DefaultContext';

class DateField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      monetField: null
    };
  }

  componentDidMount() {
    const {
      name,
      type
    } = this.props;

    const { entity } = this.context;
    const monetField = new Monet.UI.Fields.Render({
      name: name.replace(/\[|\]|\./g, ''),
      type
    }, entity).render();

    this.setState({
      monetField
    });
  }

  customValidation = (values) => {
    const { required } = this.props;
    if (required && (!values)) {
      return 'general.mandatoryField';
    }
    return undefined;
  }

  gridFormatter = () => {
    const {
      label,
      name,
      type
    } = this.props;

    return {
      id: name,
      name,
      label,
      type
    };
  };

  renderFieldContent = ({
    input,
    monetField,
    ref,
    disabled
  }) => {
    if (monetField) {
      const onChange = () => {
        const value = monetField.getValue();
        input.onChange(value);
      };

      monetField.setValue(input.value);

      if (disabled) {
        monetField.disable();
      }

      monetField.input.onchange = onChange;
    }
    return (
      <div ref={ref} />
    );
  }

  render() {
    const { monetField } = this.state;
    return (
      <BaseField
        className="dateField"
        monetField={monetField}
        renderFieldContent={this.renderFieldContent}
        customValidation={this.customValidation}
        gridFormatter={this.gridFormatter}
        {...this.props}
      />
    );
  }
}

DateField.contextType = CrudContext;

DateField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool
};

DateField.defaultProps = {
  type: 'DATE',
  disabled: false,
  required: false
};

export default DateField;
